import {computed, ref, watch, watchEffect} from "vue";
import {useI18n} from "vue-i18n";

export const usePassengers = () => {
    const {t} = useI18n();
    const passengers = ref(0);
    const cabins = ref(0);
    const skipper = ref(false);
    const minCabins = ref(0);
    const skipperCabin = ref(0);

    const text = computed(() => {

        if (passengers.value === 0 && cabins.value === 0) {
            return t('booking.selectOption');
        } else if (passengers.value === 0) {
            return t('booking.cabins', {count: cabins.value});
        } else if (cabins.value === 0) {
            return t('booking.passengers', {count: passengers.value});
        } else {
            return t('booking.passengersAndCabins', {passengers: passengers.value, cabins: cabins.value});
        }
    });

    const incrementPassenger = ()=>{
        passengers.value += 1
        computeCabins();
    }
    const decrementPassenger = ()=>{
        passengers.value = passengers.value <= 0 ? passengers.value : passengers.value - 1
        computeCabins();
    }
    const incrementCabin = ()=>{
        cabins.value = cabins.value+1
        computePassengers();
    }
    const decrementCabin = ()=>{
        cabins.value = cabins.value <= minCabins.value ? cabins.value : cabins.value - 1
        computePassengers();
    }

    const computeCabins = () => {
        if (passengers.value > 1) {
            minCabins.value = Math.ceil(passengers.value / 2) + skipperCabin.value;
            if (cabins.value < minCabins.value) {
                cabins.value = minCabins.value;
            }
        } else if (passengers.value == 1) {
            minCabins.value = passengers.value + skipperCabin.value;
            if (cabins.value < 1) {
                cabins.value = minCabins.value;
            }
        } else {
            minCabins.value = 0 + skipperCabin.value;
        }

    }

    const computePassengers = () => {
        if (cabins.value <= 0) {
            passengers.value = 0;
            return;
        }

        passengers.value = skipper.value
            ? Math.max(0, 2 * cabins.value - 1)
            : 2 * cabins.value;
    };



    watch(skipper,(newSkipper)=>{
        if (newSkipper) {
            incrementCabin()
        } else {
            decrementCabin()
        }
    })


    const reset = () => {

        passengers.value = 0;
        cabins.value = 0;
        skipper.value = false;
        passengers.value = 0;
    }

    return {
        passengers,
        cabins,
        skipper,
        text,
        reset,
        incrementPassenger,
        decrementPassenger,
        incrementCabin,
        decrementCabin
    }

}

